import Binance from './binance.svg';
import Bybit from './bybit.svg';
import Okx from './okx.svg';
import Okxdex from './okxdex.png';
import Coinbase from './coinbase.svg';
import Deribit from './deribit.svg';
import Gate from './gate.svg';
import Hyperliquid from './hyperliquid.svg';
import Tread from './tread.svg';
import Unknown from './unknown.svg';
import Bitget from './bitget.svg';
import Aster from './aster.svg';
import Pacifica from './pacifica.svg';
import Xyz from './xyz.svg';
import Paradex from './paradex.svg';
import Ventuals from './ventuals.svg';
import Felix from './felix.svg';
import Extended from './extended.svg';

const ICONS = {
  binance: Binance,
  binancepm: Binance,
  bybit: Bybit,
  coinbase: Coinbase,
  deribit: Deribit,
  okx: Okx,
  okxdex: Okxdex,
  gate: Gate,
  hyperliquid: Hyperliquid,
  default: Unknown,
  tread: Tread,
  bitget: Bitget,
  aster: Aster,
  pacifica: Pacifica,
  xyz: Xyz,
  paradex: Paradex,
  vntl: Ventuals,
  flx: Felix,
  extended: Extended,
};

export default ICONS;
